var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bem(),on:{"click":_vm.showPanel}},[_vm._t("default",[_c('gd-button',{attrs:{"rect":""}},[_vm._v(_vm._s(_vm.label))])],{"showPanel":_vm.showPanel,"label":_vm.label,"unread":_vm.unread})],2)}
var staticRenderFns = []

export { render, staticRenderFns }